import type {
  WidgetSettingsSlice,
  WorkspaceSliceCreator,
} from "./workspace.types";
import { normalizeWorkspaceSymbol } from "./workspace.utils";

const normalizeComparisonSymbols = (symbols: readonly string[]): string[] => [
  ...new Set(symbols.filter(Boolean).map(normalizeWorkspaceSymbol)),
];

export const createWidgetSettingsSlice: WorkspaceSliceCreator<
  WidgetSettingsSlice
> = (set) => ({
  widgetSettings: {},

  setPortfolioHistoryComparisons: (widgetId, comparisons) => {
    set((draft) => {
      draft.widgetSettings[widgetId] = {
        kind: "portfolioHistory",
        comparisons: comparisons.map((comparison) => ({ ...comparison })),
      };
    });
  },

  setChartState: (widgetId, state) => {
    set((draft) => {
      const current = draft.widgetSettings[widgetId];
      draft.widgetSettings[widgetId] = {
        kind: "chart",
        state: structuredClone(state),
        ...(current?.kind === "chart" && current.comparisonSymbols?.length
          ? { comparisonSymbols: [...current.comparisonSymbols] }
          : {}),
        ...(current?.kind === "chart" &&
        current.showOpenLimitOrders !== undefined
          ? { showOpenLimitOrders: current.showOpenLimitOrders }
          : {}),
        ...(current?.kind === "chart" &&
        current.showHistoricalOrderFills !== undefined
          ? { showHistoricalOrderFills: current.showHistoricalOrderFills }
          : {}),
      };
    });
  },

  setChartComparisonSymbols: (widgetId, symbols) => {
    set((draft) => {
      const current = draft.widgetSettings[widgetId];
      const comparisonSymbols = normalizeComparisonSymbols(symbols);
      draft.widgetSettings[widgetId] = {
        kind: "chart",
        state: current?.kind === "chart" ? current.state : {},
        ...(comparisonSymbols.length ? { comparisonSymbols } : {}),
        ...(current?.kind === "chart" &&
        current.showOpenLimitOrders !== undefined
          ? { showOpenLimitOrders: current.showOpenLimitOrders }
          : {}),
        ...(current?.kind === "chart" &&
        current.showHistoricalOrderFills !== undefined
          ? { showHistoricalOrderFills: current.showHistoricalOrderFills }
          : {}),
      };
    });
  },

  setChartOpenLimitOrdersVisible: (widgetId, visible) => {
    set((draft) => {
      const current = draft.widgetSettings[widgetId];
      draft.widgetSettings[widgetId] = {
        kind: "chart",
        state: current?.kind === "chart" ? current.state : {},
        ...(current?.kind === "chart" && current.comparisonSymbols?.length
          ? { comparisonSymbols: [...current.comparisonSymbols] }
          : {}),
        showOpenLimitOrders: visible,
        ...(current?.kind === "chart" &&
        current.showHistoricalOrderFills !== undefined
          ? { showHistoricalOrderFills: current.showHistoricalOrderFills }
          : {}),
      };
    });
  },

  setChartHistoricalOrderFillsVisible: (widgetId, visible) => {
    set((draft) => {
      const current = draft.widgetSettings[widgetId];
      draft.widgetSettings[widgetId] = {
        kind: "chart",
        state: current?.kind === "chart" ? current.state : {},
        ...(current?.kind === "chart" && current.comparisonSymbols?.length
          ? { comparisonSymbols: [...current.comparisonSymbols] }
          : {}),
        ...(current?.kind === "chart" &&
        current.showOpenLimitOrders !== undefined
          ? { showOpenLimitOrders: current.showOpenLimitOrders }
          : {}),
        showHistoricalOrderFills: visible,
      };
    });
  },
});
